import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { Reason, ReasonScope } from "@models/reason.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PermissionService } from "@app/authentication/services/permission.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-reasons-create-modal',
    templateUrl: './reasons-create-modal.component.html',
    styleUrls: ['./reasons-create-modal.component.scss']
})
export class ReasonsCreateModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output('onCreate') onCreate: EventEmitter<any> = new EventEmitter();
    @Output('onUpdate') onUpdate: EventEmitter<any> = new EventEmitter();
    @Output('onDelete') onDelete: EventEmitter<any> = new EventEmitter();

    @Input() isLoading;

    public reason: Reason = new Reason();

    reasonForm: UntypedFormGroup;

    scopeOptions = [];

    previousReasonName = '';

    showValidations = false;

    constructor(private permissionService: PermissionService,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.onFormInit();
    }

    open(editReason = new Reason()) {
        this.buildScopeOptions();
        this.loadFormValue(editReason);
        this.previousReasonName = editReason.name || '';
        this.showValidations = false;
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    private loadFormValue(reason) {
        this.reason = reason;
        this.reasonForm.setValue({
            name: reason.name,
            scope: reason.scope ?? ReasonScope.ToolIssue
        });
    }

    onFormInit() {
        this.reasonForm = new UntypedFormGroup({
            name: new UntypedFormControl(this.reason.name, Validators.required),
            scope: new UntypedFormControl(this.reason.scope ?? ReasonScope.ToolIssue, Validators.required),
        });
    }

    createReason() {
        if (this.reasonForm.invalid) {
            this.showValidations = true;
            return;
        }
        this.onCreate.emit(this.getFormValue());
    }

    updateReason() {
        if (this.reasonForm.invalid) {
            this.showValidations = true;
            return;
        }
        this.onUpdate.emit({
            previousReasonName: this.previousReasonName,
            newReason: this.getFormValue()
        });
    }

    deleteReason() {
        this.onDelete.emit(this.getFormValue());
    }

    get isEditMode() {
        return !!this.reason.id;
    }

    getFormValue() {
        return Object.assign(this.reason, this.reasonForm.getRawValue());
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_REASONS');
    }

    private buildScopeOptions() {
        this.scopeOptions = [
            {
                name: this.translateService.instant('admin.reasons.modal.scope.options.toolIssue'),
                value: ReasonScope.ToolIssue
            },
            {
                name: this.translateService.instant('admin.reasons.modal.scope.options.ticketOnHold'),
                value: ReasonScope.TicketOnHold
            }
        ];
    }
}
